import barrasimulador2 from '../assets/barraSimulador2.png';
import ban100 from '../assets/ban100Universal.png';
import BarrasInfo from '../components/personas/CDTs/BarrasInfo';
import Formulario from '../components/personas/CDTs/Formulario';

function CdtFormulario() {
    return (
        <div className='bg-[#0346a4] px-28 pb-20 pt-10'>
            <div className='bg-[#e8f2f4] rounded-3xl p-3 mb-4'>
                <div className="bg-[#e8f2f4]  rounded-lg mb-2 max-w-[1000px] relative z-10">
                    <img src={barrasimulador2} alt="Barra simulador" className="w-full" />
                </div>
                <div className='grid grid-cols-9 gap-4 text-[#032c65] font-bold items-center'>
                    <img src={ban100} alt="Ban100" className="col-span-1 mx-auto" />
                    <p className='col-span-2 flex items-center' style={{ textShadow: '2px 5px 5px rgba(0,0,0,0.4)' }}><span className="text-4xl mr-2 mb-1">→</span> Cantidad: $5.000.000</p>
                    <p className='col-span-2 flex items-center' style={{ textShadow: '2px 5px 5px rgba(0,0,0,0.4)' }}><span className="text-4xl mr-2 mb-1">→</span> Duración: 6 meses</p>
                    <p className='col-span-2 flex items-center' style={{ textShadow: '2px 5px 5px rgba(0,0,0,0.4)' }}><span className="text-4xl mr-2 mb-1">→</span> Pago al vencimiento</p>
                    <p className='col-span-2 flex items-center' style={{ textShadow: '2px 5px 5px rgba(0,0,0,0.4)' }}><span className="text-4xl mr-2 mb-1">→</span> Tasa: 10.6%</p>
                </div>
            </div>
            <div className='grid grid-cols-9 gap-4'>
                <div className='bg-[#e8f2f4] rounded-3xl py-10 px-10 col-span-3 '>
                    <p className='text-xl font-bold text-[#0054c9]' style={{ textShadow: '2px 3px 3px rgba(0,0,0,0.3)' }}>Datos personales</p>
                    <p className='text-[#0054c9] text-lg font-bold' style={{ textShadow: '2px 3px 3px rgba(0,0,0,0.3)' }}>Cuéntale a Ban100 sobre tí</p>
                    <div className="bg-[#e8f2f4]  rounded-lg mb-2 max-w-[1000px] relative z-10" >
                        <BarrasInfo personales={60} financieros={20} otros={20} />
                    </div>
                    <p className='text-[#0054c9] text-lg font-bold leading-tight ' style={{ textShadow: '2px 3px 3px rgba(0,0,0,0.3)' }}>¿Por qué necesitamos tu información personal?</p>
                    <p className='py-3 text-[#032c65] text-lg font-semibold leading-tight'>En nuestro compromiso por ofrecerte el mejor servicio, te solicitamos ciertos datos personales que son esenciales para procesar tu solicitud. Estos datos nos permiten: </p>
                    <p className='text-[#032c65] text-lg font-semibold leading-tight'>Verificar tu identidad: (Ver más) Procesar tu solicitud: (Ver más) Cumplir con normativas legales: (Ver más) </p>
                    <p className='pt-3 text-[#032c65] text-lg font-semibold leading-tight'>¿Necesitas ayuda con tu información personal? escríbenos aquí</p>


                </div>
                <div className='col-span-6 '>
                    <Formulario></Formulario>

                </div>
            </div>



        </div>

    )
}
export default CdtFormulario;
